webpackJsonp([44824713336471],{

/***/ 809:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint react/no-unknown-property: 0 */
	
	/**
	 * Spotify player iframe widget
	 *
	 * @author Alexander Wallin <office@alexanderwallin.com>
	 * @see https://developer.spotify.com/technologies/widgets/spotify-play-button/
	 */
	
	// Dimension prop type
	var dimensionPropType = _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]);
	
	// Size presets, defined by Spotify
	var sizePresets = {
	  large: {
	    width: 300,
	    height: 380
	  },
	  compact: {
	    width: 300,
	    height: 80
	  }
	};
	
	/**
	 * SpotifyPlayer class
	 */
	
	var SpotifyPlayer = function (_Component) {
	  _inherits(SpotifyPlayer, _Component);
	
	  function SpotifyPlayer() {
	    _classCallCheck(this, SpotifyPlayer);
	
	    return _possibleConstructorReturn(this, (SpotifyPlayer.__proto__ || Object.getPrototypeOf(SpotifyPlayer)).apply(this, arguments));
	  }
	
	  _createClass(SpotifyPlayer, [{
	    key: 'render',
	
	
	    // ------------------------------------------------------
	    // Render
	    // ------------------------------------------------------
	
	    value: function render() {
	      var _props = this.props,
	          uri = _props.uri,
	          view = _props.view,
	          theme = _props.theme;
	      var size = this.props.size;
	
	
	      if (typeof size === 'string') {
	        size = sizePresets[size];
	      }
	
	      return _react2.default.createElement('iframe', {
	        title: 'Spotify',
	        className: 'SpotifyPlayer',
	        src: 'https://embed.spotify.com/?uri=' + uri + '&view=' + view + '&theme=' + theme,
	        width: size.width,
	        height: size.height,
	        frameBorder: '0',
	        allowtransparency: 'true'
	      });
	    }
	  }]);
	
	  return SpotifyPlayer;
	}(_react.Component);
	
	SpotifyPlayer.propTypes = {
	
	  // Spotify URI
	  uri: _propTypes2.default.string.isRequired,
	
	  // Size as either a preset or as custom dimensions
	  size: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['large', 'compact']), _propTypes2.default.shape({
	    width: dimensionPropType,
	    height: dimensionPropType
	  })]),
	
	  // View
	  view: _propTypes2.default.oneOf(['list', 'coverart']),
	
	  // Theme
	  theme: _propTypes2.default.oneOf(['black', 'white'])
	};
	
	SpotifyPlayer.defaultProps = {
	  size: 'large',
	  view: 'list',
	  theme: 'black'
	};
	
	exports.default = SpotifyPlayer;

/***/ }),

/***/ 831:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 833:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 834:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 835:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 836:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 840:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 326:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n        padding-bottom: 80px;\n    "], ["\n        padding-bottom: 80px;\n    "]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n        font-size: 13px;\n    "], ["\n        font-size: 13px;\n    "]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n        height: 180px;\n    "], ["\n        height: 180px;\n    "]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n        margin-top: 45px;\n    "], ["\n        margin-top: 45px;\n    "]),
	    _templateObject5 = _taggedTemplateLiteralLoose(["\n        margin-top: 35px;\n        font-size: 30px;\n        line-height: 32px;\n    "], ["\n        margin-top: 35px;\n        font-size: 30px;\n        line-height: 32px;\n    "]),
	    _templateObject6 = _taggedTemplateLiteralLoose(["\n        font-size: 18px;\n        line-height: 28px;\n    "], ["\n        font-size: 18px;\n        line-height: 28px;\n    "]),
	    _templateObject7 = _taggedTemplateLiteralLoose(["\n        flex-direction: column;\n        margin-top: 10px;\n    "], ["\n        flex-direction: column;\n        margin-top: 10px;\n    "]),
	    _templateObject8 = _taggedTemplateLiteralLoose([" \n        ", ",\n        ", " {     \n            font-size: 10px;\n        }\n\n        ", " {\n            display: flex;\n        }\n\n        ", " {\n            display: none;\n        }\n\n        &:not(:last-child) {\n            margin-right: 0;\n            margin-bottom: 2px;\n        }\n\n    "], [" \n        ", ",\n        ", " {     \n            font-size: 10px;\n        }\n\n        ", " {\n            display: flex;\n        }\n\n        ", " {\n            display: none;\n        }\n\n        &:not(:last-child) {\n            margin-right: 0;\n            margin-bottom: 2px;\n        }\n\n    "]),
	    _templateObject9 = _taggedTemplateLiteralLoose(["\n        margin-top: ", "px;\n        padding: 0;\n    "], ["\n        margin-top: ", "px;\n        padding: 0;\n    "]),
	    _templateObject10 = _taggedTemplateLiteralLoose(["\n            font-size: 14px;\n            line-height: 24px;\n        "], ["\n            font-size: 14px;\n            line-height: 24px;\n        "]),
	    _templateObject11 = _taggedTemplateLiteralLoose(["\n            /* height: 204px; */\n        "], ["\n            /* height: 204px; */\n        "]),
	    _templateObject12 = _taggedTemplateLiteralLoose(["\n            height: 204px;\n        "], ["\n            height: 204px;\n        "]),
	    _templateObject13 = _taggedTemplateLiteralLoose(["\n        ", " {\n            margin: 24px 0 18px;\n\n            ", ", \n            ", " {\n                font-size: 20px;\n                line-height: 30px;\n            }\n\n            ", " {\n                margin-right: 4px;\n            }\n        }\n\n        ", " {\n            margin-bottom: 38px;\n        }\n\n        ", " {\n            height: 165px;\n        }\n    "], ["\n        ", " {\n            margin: 24px 0 18px;\n\n            ", ", \n            ", " {\n                font-size: 20px;\n                line-height: 30px;\n            }\n\n            ", " {\n                margin-right: 4px;\n            }\n        }\n\n        ", " {\n            margin-bottom: 38px;\n        }\n\n        ", " {\n            height: 165px;\n        }\n    "]),
	    _templateObject14 = _taggedTemplateLiteralLoose(["\n            font-size: 20px;\n            line-height: 30px;\n        "], ["\n            font-size: 20px;\n            line-height: 30px;\n        "]),
	    _templateObject15 = _taggedTemplateLiteralLoose(["\n        margin-top: 60px;\n    "], ["\n        margin-top: 60px;\n    "]),
	    _templateObject16 = _taggedTemplateLiteralLoose(["\n        margin-bottom: 60px;\n    "], ["\n        margin-bottom: 60px;\n    "]),
	    _templateObject17 = _taggedTemplateLiteralLoose(["\n\t\tfont-size: 8px;\n\t\tborder: 1px solid black;\n\t\theight: 19px;\n\t"], ["\n\t\tfont-size: 8px;\n\t\tborder: 1px solid black;\n\t\theight: 19px;\n\t"]),
	    _templateObject18 = _taggedTemplateLiteralLoose(["\n            font-size: 16px;\n            margin: 41px 0;\n        "], ["\n            font-size: 16px;\n            margin: 41px 0;\n        "]),
	    _templateObject19 = _taggedTemplateLiteralLoose(["\n        flex-direction: column;\n        align-items: center;\n    "], ["\n        flex-direction: column;\n        align-items: center;\n    "]),
	    _templateObject20 = _taggedTemplateLiteralLoose(["\n        max-width: 270px;\n        width: 100%;\n        flex: 0 1 auto;\n\n        ", " {\n            height: 270px;\n        }\n    \n        &:not(:last-child) {\n            margin-right: 0;\n            margin-bottom: 15px;\n        }\n\n    "], ["\n        max-width: 270px;\n        width: 100%;\n        flex: 0 1 auto;\n\n        ", " {\n            height: 270px;\n        }\n    \n        &:not(:last-child) {\n            margin-right: 0;\n            margin-bottom: 15px;\n        }\n\n    "]),
	    _templateObject21 = _taggedTemplateLiteralLoose(["\n                    transform: none;\n                "], ["\n                    transform: none;\n                "]),
	    _templateObject22 = _taggedTemplateLiteralLoose(["\n        position: static !important;\n        transform: none;\n        width: 176px;\n        height: 98px;\n        box-shadow: 10px 10px 0 0 #000000;\n        margin-top: 57px;\n\n        ", " {\n            height: 40px;\n            font-size: 12px;\n            transform: none;\n            order: 2;\n        }\n    "], ["\n        position: static !important;\n        transform: none;\n        width: 176px;\n        height: 98px;\n        box-shadow: 10px 10px 0 0 #000000;\n        margin-top: 57px;\n\n        ", " {\n            height: 40px;\n            font-size: 12px;\n            transform: none;\n            order: 2;\n        }\n    "]),
	    _templateObject23 = _taggedTemplateLiteralLoose(["\n                    width: 21px;\n                    height: 29px;\n                    order: 1;\n                "], ["\n                    width: 21px;\n                    height: 29px;\n                    order: 1;\n                "]),
	    _templateObject24 = _taggedTemplateLiteralLoose(["\n                    width: 29px;\n                    height: 25px;\n                    order: 2;\n                "], ["\n                    width: 29px;\n                    height: 25px;\n                    order: 2;\n                "]),
	    _templateObject25 = _taggedTemplateLiteralLoose(["\n                    width: 31px;\n                    height: 22px;\n                    order: 3;\n                "], ["\n                    width: 31px;\n                    height: 22px;\n                    order: 3;\n                "]),
	    _templateObject26 = _taggedTemplateLiteralLoose(["\n\n        &:first-child {\n            order: 3;\n            border-right: 0;\n        }\n\n        &:nth-child(2) {\n            order: 1;\n            border-left: 2px solid black;\n        }\n\n        ", " {\n            transform: none;\n        }\n    "], ["\n\n        &:first-child {\n            order: 3;\n            border-right: 0;\n        }\n\n        &:nth-child(2) {\n            order: 1;\n            border-left: 2px solid black;\n        }\n\n        ", " {\n            transform: none;\n        }\n    "]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _gatsbyLink = __webpack_require__(14);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _lodash = __webpack_require__(40);
	
	var _polished = __webpack_require__(23);
	
	var _reactMasonryComponent = __webpack_require__(68);
	
	var _reactMasonryComponent2 = _interopRequireDefault(_reactMasonryComponent);
	
	var _reactVisibilitySensor = __webpack_require__(100);
	
	var _reactVisibilitySensor2 = _interopRequireDefault(_reactVisibilitySensor);
	
	var _velocityReact = __webpack_require__(25);
	
	var _reactScrollParallax = __webpack_require__(54);
	
	var _reactSpotifyPlayer = __webpack_require__(809);
	
	var _reactSpotifyPlayer2 = _interopRequireDefault(_reactSpotifyPlayer);
	
	var _gatsbyPluginPageTransitions = __webpack_require__(63);
	
	var _gatsbyPluginPageTransitions2 = _interopRequireDefault(_gatsbyPluginPageTransitions);
	
	var _reactPlayer = __webpack_require__(176);
	
	var _reactPlayer2 = _interopRequireDefault(_reactPlayer);
	
	var _moment = __webpack_require__(168);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _metaAuthor = __webpack_require__(834);
	
	var _metaAuthor2 = _interopRequireDefault(_metaAuthor);
	
	var _metaPhotographer = __webpack_require__(836);
	
	var _metaPhotographer2 = _interopRequireDefault(_metaPhotographer);
	
	var _metaDate = __webpack_require__(835);
	
	var _metaDate2 = _interopRequireDefault(_metaDate);
	
	var _facebook = __webpack_require__(831);
	
	var _facebook2 = _interopRequireDefault(_facebook);
	
	var _twitter = __webpack_require__(840);
	
	var _twitter2 = _interopRequireDefault(_twitter);
	
	var _mail = __webpack_require__(833);
	
	var _mail2 = _interopRequireDefault(_mail);
	
	var _components = __webpack_require__(18);
	
	var _global = __webpack_require__(6);
	
	var _utils = __webpack_require__(5);
	
	var _fonts = __webpack_require__(42);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var lastScrollY = 0;
	var ticking = false;
	
	var Article = function (_Component) {
	    _inherits(Article, _Component);
	
	    function Article() {
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, Article);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	            data: null,
	            blocks: null,
	            acf: null,
	            shareActive: false,
	            shareFixed: false
	        }, _this.componentWillMount = function () {
	            var data = _this.props.data.wordpressArticles;
	
	            // Map data to state
	
	            _this.setState({
	                data: data,
	                blocks: JSON.parse(data.acf.content_blocks),
	                acf: data.acf
	            });
	        }, _this.componentDidMount = function () {
	            window.addEventListener('scroll', _this.handleScroll);
	        }, _this.componentWillUnmount = function () {
	            window.removeEventListener('scroll', _this.handleScroll);
	        }, _this.handleScroll = function () {
	            var shareFixed = _this.state.shareFixed;
	
	            lastScrollY = window.scrollY;
	
	            if (!ticking) {
	                window.requestAnimationFrame(function () {
	                    var fixedPoint = (_utils.width.phone() ? 800 : 1550) - (_utils.width.phone() ? window.innerHeight * 0.7 : window.innerHeight / 2);
	
	                    if (lastScrollY >= fixedPoint && !shareFixed) {
	                        _this.setState({
	                            shareFixed: true
	                        });
	                    }
	
	                    if (lastScrollY < fixedPoint && shareFixed) {
	                        _this.setState({
	                            shareFixed: false
	                        });
	                    }
	
	                    ticking = false;
	                });
	
	                ticking = true;
	            }
	        }, _this.toggleShare = function () {
	            var shareActive = _this.props.shareActive;
	
	
	            if (!shareActive) {
	                _this.setState({
	                    shareActive: true
	                }, function () {
	                    setTimeout(function () {
	                        _this.setState({
	                            shareActive: false
	                        });
	                    }, 5000);
	                });
	            }
	        }, _this.renderShare = function () {
	            var _this$state = _this.state,
	                shareActive = _this$state.shareActive,
	                shareFixed = _this$state.shareFixed;
	
	
	            return _react2.default.createElement(
	                Share,
	                {
	                    active: shareActive,
	                    className: shareFixed ? 'fixed' : '',
	                    onClick: _this.toggleShare
	                },
	                _react2.default.createElement(
	                    Heading,
	                    null,
	                    "Share"
	                ),
	                _react2.default.createElement(
	                    Functions,
	                    null,
	                    typeof window !== 'undefined' && _react2.default.createElement(
	                        _react2.default.Fragment,
	                        null,
	                        _react2.default.createElement(
	                            Function,
	                            {
	                                type: 'mail',
	                                target: '_blank',
	                                href: "mailto:?&body=" + window.location
	                            },
	                            _react2.default.createElement(Image, null)
	                        ),
	                        _react2.default.createElement(
	                            Function,
	                            {
	                                type: 'twitter',
	                                target: '_blank',
	                                href: "https://twitter.com/intent/tweet?url=" + encodeURI(window.location)
	                            },
	                            _react2.default.createElement(Image, null)
	                        ),
	                        _react2.default.createElement(
	                            Function,
	                            {
	                                type: 'facebook',
	                                target: '_blank',
	                                href: "https://www.facebook.com/sharer.php?u=" + window.location
	                            },
	                            _react2.default.createElement(Image, null)
	                        )
	                    )
	                )
	            );
	        }, _this.getMainSection = function () {
	            var data = _this.state.data;
	
	            var mainSection = (0, _lodash.find)(data.sections, { isSub: false });
	            if (mainSection) {
	                return _react2.default.createElement(
	                    Tag,
	                    {
	                        to: "/articles/" + mainSection.slug
	                    },
	                    mainSection.name
	                );
	            }
	        }, _this.getFirstSubsection = function () {
	            var data = _this.state.data;
	
	            var firstSubsection = (0, _lodash.find)(data.sections, { isSub: true });
	
	            if (firstSubsection) {
	                return _react2.default.createElement(
	                    Tag,
	                    {
	                        to: "/articles/" + firstSubsection.slug
	                    },
	                    firstSubsection.name
	                );
	            }
	        }, _this.renderCredits = function () {
	            var data = _this.state.data;
	
	
	            return data && _react2.default.createElement(
	                MetaContainer,
	                null,
	                _react2.default.createElement(
	                    Meta,
	                    {
	                        type: 'author'
	                    },
	                    _react2.default.createElement(Icon, null),
	                    _react2.default.createElement(
	                        Mobile,
	                        null,
	                        "Author:"
	                    ),
	                    _react2.default.createElement(
	                        Text,
	                        null,
	                        data.acf.author
	                    )
	                ),
	                data.acf.photographer && _react2.default.createElement(
	                    Meta,
	                    {
	                        type: 'photographer'
	                    },
	                    _react2.default.createElement(Icon, null),
	                    _react2.default.createElement(
	                        Mobile,
	                        null,
	                        "Photographer:"
	                    ),
	                    _react2.default.createElement(
	                        Text,
	                        null,
	                        data.acf.photographer
	                    )
	                ),
	                _react2.default.createElement(
	                    Meta,
	                    {
	                        type: 'date'
	                    },
	                    _react2.default.createElement(Icon, null),
	                    _react2.default.createElement(
	                        Mobile,
	                        null,
	                        "Date:"
	                    ),
	                    _react2.default.createElement(
	                        Text,
	                        null,
	                        _moment2.default.unix(data.publishedDate).format('D MMMM YYYY')
	                    )
	                )
	            );
	        }, _this.renderTags = function () {
	            var data = _this.state.data;
	
	
	            if (data && data.tags) {
	                var tags = data.tags.map(function (tag, i) {
	                    return _react2.default.createElement(
	                        Tag,
	                        null,
	                        tag.name
	                    );
	                });
	
	                return _react2.default.createElement(
	                    TagSection,
	                    null,
	                    _react2.default.createElement(
	                        Tags,
	                        null,
	                        _this.getMainSection(),
	                        _this.getFirstSubsection(),
	                        tags
	                    ),
	                    _react2.default.createElement(Line, null)
	                );
	            }
	        }, _this.renderShop = function () {
	            var acf = _this.state.acf;
	
	
	            if (acf && acf.shop_display_block) {
	                return _react2.default.createElement(
	                    Shop,
	                    null,
	                    _react2.default.createElement(
	                        Heading,
	                        null,
	                        acf.shop_heading || ''
	                    ),
	                    _react2.default.createElement(
	                        Products,
	                        null,
	                        _this.renderShopProducts(acf.shop_products)
	                    )
	                );
	            }
	        }, _this.renderShopProducts = function (products) {
	            return products.map(function (product, i) {
	                return _react2.default.createElement(
	                    Product,
	                    {
	                        href: product.link,
	                        key: i
	                    },
	                    _react2.default.createElement(Image, {
	                        image: "https://" + product.image_url
	                    }),
	                    _react2.default.createElement(
	                        Info,
	                        null,
	                        product.title
	                    )
	                );
	            });
	        }, _this.renderBlocks = function () {
	            var blocks = _this.state.blocks;
	
	
	            if (blocks) {
	                return blocks.map(function (block, i) {
	                    var type = block.acf_fc_layout;
	
	                    return _react2.default.createElement(
	                        Block,
	                        {
	                            layout: type,
	                            firstBlock: i == 0,
	                            key: i
	                        },
	                        type == 'text' && _this.renderTextBlock(block),
	                        type == 'quote' && _this.renderQuoteBlock(block),
	                        type == 'listicle' && _this.renderListicleBlock(block),
	                        type == 'question_answer' && _this.renderQABlock(block),
	                        type == 'image' && _this.renderImageBlock(block),
	                        type == 'video_player' && _this.renderVideoBlock(block),
	                        type == 'spotify_player' && _this.renderSpotifyBlock(block),
	                        type == 'image_slideshow' && _this.renderSlideshowBlock(block)
	                    );
	                });
	            }
	        }, _this.renderTextBlock = function (block) {
	            return _react2.default.createElement(Text, {
	                dangerouslySetInnerHTML: { __html: block.content }
	            });
	        }, _this.renderQuoteBlock = function (block) {
	            return _react2.default.createElement(Text, {
	                dangerouslySetInnerHTML: { __html: block.content }
	            });
	        }, _this.renderListicleBlock = function (block) {
	
	            var imageSrc = block.image.sizes.medium2;
	            if (block.image.mime_type == 'image/gif') imageSrc = block.image.url;
	
	            return _react2.default.createElement(
	                _react2.default.Fragment,
	                null,
	                _react2.default.createElement(Line, null),
	                _react2.default.createElement(Img, {
	                    src: block.image && imageSrc
	                }),
	                block.use_caption && _react2.default.createElement(Caption, {
	                    dangerouslySetInnerHTML: { __html: block.caption }
	                }),
	                _react2.default.createElement(
	                    Heading,
	                    null,
	                    _react2.default.createElement(
	                        Number,
	                        null,
	                        "#",
	                        block.number
	                    ),
	                    _react2.default.createElement(
	                        HeadingText,
	                        null,
	                        block.heading
	                    )
	                ),
	                _react2.default.createElement(Text, {
	                    dangerouslySetInnerHTML: { __html: block.text }
	                })
	            );
	        }, _this.renderQABlock = function (block) {
	            return _react2.default.createElement(
	                _react2.default.Fragment,
	                null,
	                _react2.default.createElement(Question, {
	                    dangerouslySetInnerHTML: { __html: block.question }
	                }),
	                _react2.default.createElement(Answer, {
	                    dangerouslySetInnerHTML: { __html: block.answer }
	                })
	            );
	        }, _this.renderImageBlock = function (block) {
	
	            if (!block.image) return;
	
	            var imageSrc = block.image.sizes.medium2;
	            if (block.image.mime_type == 'image/gif') imageSrc = block.image.url;
	
	            return _react2.default.createElement(
	                _react2.default.Fragment,
	                null,
	                _react2.default.createElement(Img, {
	                    src: imageSrc
	                }),
	                block.use_caption && _react2.default.createElement(Caption, {
	                    dangerouslySetInnerHTML: { __html: block.caption }
	                })
	            );
	        }, _this.renderVideoBlock = function (block) {
	            return _react2.default.createElement(_reactPlayer2.default, {
	                url: block.src,
	                controls: true,
	                height: _utils.width.phone() ? '204px' : '475px',
	                width: '100%'
	            });
	        }, _this.renderSpotifyBlock = function (block) {
	            return _react2.default.createElement(_reactSpotifyPlayer2.default, {
	                uri: block.uri,
	                size: 'large',
	                view: 'list',
	                theme: 'white'
	            });
	        }, _this.renderSlideshowBlock = function (block) {
	
	            var slides = block.slider.map(function (slide, i) {
	
	                var imageSrc = slide.image.sizes.fullwidth;
	                if (slide.image.mime_type == 'image/gif') imageSrc = slide.image.url;
	
	                return _react2.default.createElement(Image, {
	                    image: imageSrc
	                });
	            });
	
	            return _react2.default.createElement(
	                _react2.default.Fragment,
	                null,
	                _react2.default.createElement(_components.Carousel, {
	                    slides: slides,
	                    ref: _this.slider,
	                    styles: carouselStyles,
	                    controls: true,
	                    settings: {
	                        dots: false,
	                        infinite: true,
	                        speed: 1000,
	                        slidesToShow: 1,
	                        slidesToScroll: 1,
	                        autoplay: false,
	                        autoplaySpeed: 400,
	                        pauseOnHover: false
	                    }
	                }),
	                block.use_caption && _react2.default.createElement(Caption, {
	                    dangerouslySetInnerHTML: { __html: block.caption }
	                })
	            );
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    // Share 
	
	    // Meta
	
	    // Credits
	
	    // Tags
	
	    // Shop
	
	    // Block render functions
	
	    Article.prototype.render = function render() {
	        var _state = this.state,
	            data = _state.data,
	            acf = _state.acf;
	
	
	        return _react2.default.createElement(
	            _gatsbyPluginPageTransitions2.default,
	            null,
	            data && _react2.default.createElement(_components.MetaTags, {
	                title: "Mambo World \u2014 " + data.title,
	                description: acf.meta_description,
	                url: "https://www.mamboworld.com.au/article/" + data.slug,
	                image: acf.hero_image.sizes.medium2
	            }),
	            _react2.default.createElement(
	                Wrapper,
	                null,
	                data && _react2.default.createElement(Hero, {
	                    height: acf.height,
	                    image: acf.hero_image && acf.hero_image.sizes.xlarge
	                }),
	                _react2.default.createElement(
	                    Container,
	                    null,
	                    data && _react2.default.createElement(
	                        ArticleHeading,
	                        {
	                            type: acf.title_style
	                        },
	                        data.title
	                    ),
	                    data && data.acf.byline && _react2.default.createElement(
	                        ArticleByline,
	                        null,
	                        data.acf.byline
	                    ),
	                    this.renderCredits(),
	                    this.renderBlocks(),
	                    this.renderTags(),
	                    this.renderShop(),
	                    this.renderShare()
	                )
	            )
	        );
	    };
	
	    return Article;
	}(_react.Component);
	
	var Wrapper = _styledComponents2.default.div.withConfig({
	    displayName: "article__Wrapper",
	    componentId: "rp54u7-0"
	})(["display:flex;flex-direction:column;align-items:center;width:100%;color:black;position:relative;"]);
	
	var Container = _styledComponents2.default.div.withConfig({
	    displayName: "article__Container",
	    componentId: "rp54u7-1"
	})(["", " ", " flex-direction:column;align-items:center;padding-bottom:120px;flex:1;", ""], _global.container, _global.padding, _utils.media.phone(_templateObject));
	
	// Shared
	
	var Text = _styledComponents2.default.div.withConfig({
	    displayName: "article__Text",
	    componentId: "rp54u7-2"
	})([""]);
	var Heading = _styledComponents2.default.div.withConfig({
	    displayName: "article__Heading",
	    componentId: "rp54u7-3"
	})([""]);
	var Mobile = _styledComponents2.default.div.withConfig({
	    displayName: "article__Mobile",
	    componentId: "rp54u7-4"
	})([""]);
	var Image = _styledComponents2.default.div.withConfig({
	    displayName: "article__Image",
	    componentId: "rp54u7-5"
	})(["background-image:url(", ");", ""], function (props) {
	    return props.image;
	}, _global.bgImage);
	
	var Img = _styledComponents2.default.img.withConfig({
	    displayName: "article__Img",
	    componentId: "rp54u7-6"
	})(["width:100%;height:auto;"]);
	
	var Caption = _styledComponents2.default.div.withConfig({
	    displayName: "article__Caption",
	    componentId: "rp54u7-7"
	})(["font-family:'GT America';font-weight:300;text-align:center;margin:0 auto;padding:20px 40px;font-size:16px;", "  "], _utils.media.phone(_templateObject2));
	
	var Line = _styledComponents2.default.div.withConfig({
	    displayName: "article__Line",
	    componentId: "rp54u7-8"
	})(["width:100%;border-top:2px solid black;"]);
	
	// Hero
	
	var Hero = _styledComponents2.default.div.withConfig({
	    displayName: "article__Hero",
	    componentId: "rp54u7-9"
	})(["height:", "px;width:100%;background:", ";background-image:url(", ");", ";", "  "], function (props) {
	    return props.height ? props.height : 650;
	}, (0, _polished.rgba)('black', 0.2), function (props) {
	    return props.image;
	}, _global.bgImage, _utils.media.phone(_templateObject3));
	
	// Heading
	
	var ArticleHeading = _styledComponents2.default.div.withConfig({
	    displayName: "article__ArticleHeading",
	    componentId: "rp54u7-10"
	})(["font-size:75px;line-height:75px;text-transform:uppercase;text-align:center;margin-top:90px;max-width:790px;", " ", " ", ""], function (props) {
	    return (0, _fonts.resolveHeaderType)(props.type);
	}, _utils.media.tablet(_templateObject4), _utils.media.phone(_templateObject5));
	
	// Byline
	
	var ArticleByline = _styledComponents2.default.div.withConfig({
	    displayName: "article__ArticleByline",
	    componentId: "rp54u7-11"
	})(["font-family:'GT America';font-size:32px;line-height:42px;font-weight:300;text-align:center;margin-top:10px;max-width:800px;", ""], _utils.media.phone(_templateObject6));
	
	// Credits
	
	var MetaContainer = _styledComponents2.default.div.withConfig({
	    displayName: "article__MetaContainer",
	    componentId: "rp54u7-12"
	})(["display:flex;align-items:center;margin-top:22px;", ""], _utils.media.phone(_templateObject7));
	
	var Icon = _styledComponents2.default.div.withConfig({
	    displayName: "article__Icon",
	    componentId: "rp54u7-13"
	})(["", " margin-right:8px;"], _global.bgIcon);
	
	var Meta = _styledComponents2.default.div.withConfig({
	    displayName: "article__Meta",
	    componentId: "rp54u7-14"
	})(["display:flex;align-items:center;", ",", "{font-family:'GT America Expanded Bold';font-size:12px;text-transform:uppercase;}", "{display:none;margin-right:8px;color:#B1B1B1;}&:not(:last-child){margin-right:38px;}", " ", ""], Text, Mobile, Mobile, function (props) {
	    if (props.type == 'author') return (0, _styledComponents.css)(["", "{width:27px;height:28px;background-image:url(", ");}"], Icon, _metaAuthor2.default);
	
	    if (props.type == 'photographer') return (0, _styledComponents.css)(["", "{width:32px;height:25px;background-image:url(", ");transform:translateY(-2px)}"], Icon, _metaPhotographer2.default);
	
	    if (props.type == 'date') return (0, _styledComponents.css)(["", "{width:28px;height:28px;background-image:url(", ");}"], Icon, _metaDate2.default);
	}, _utils.media.phone(_templateObject8, Text, Mobile, Mobile, Icon));
	
	// Blocks
	
	var blockWidth = '880px';
	
	var Block = _styledComponents2.default.div.withConfig({
	    displayName: "article__Block",
	    componentId: "rp54u7-15"
	})(["padding:0 20px;margin-top:", "px;box-sizing:border-box;width:100%;max-width:", ";p:last-child{margin-bottom:0;}font-family:'GT America';font-weight:300;text-align:center;", " ", "  "], function (props) {
	    return props.firstBlock ? 70 : 70;
	}, blockWidth, _utils.media.phone(_templateObject9, function (props) {
	    return props.firstBlock ? 30 : 55;
	}), function (props) {
	    if (props.layout == 'text') return blockText;
	    if (props.layout == 'image') return blockImage;
	    if (props.layout == 'question_answer') return blockQA;
	    if (props.layout == 'video') return blockVideo;
	    if (props.layout == 'spotify_player') return blockSpotify;
	    if (props.layout == 'listicle') return blockListicle;
	    if (props.layout == 'quote') return blockQuote;
	    if (props.layout == 'image_slideshow') return blockSlideshow;
	});
	
	// Block Text
	
	var blockText = (0, _styledComponents.css)(["", "{font-size:20px;line-height:34px;", "}"], Text, _utils.media.phone(_templateObject10));
	
	// Block Image
	
	var blockImage = (0, _styledComponents.css)(["", "{border:2px solid black;", "}"], Img, _utils.media.phone(_templateObject11));
	
	// Block Slideshow
	
	var blockSlideshow = (0, _styledComponents.css)([""]);
	
	var carouselStyles = (0, _styledComponents.css)(["> *:first-child{border:2px solid black;}", "{height:502px;", "}"], Image, _utils.media.phone(_templateObject12));
	
	// Block Listicle
	
	var Number = _styledComponents2.default.div.withConfig({
	    displayName: "article__Number",
	    componentId: "rp54u7-16"
	})([""]);
	var HeadingText = _styledComponents2.default.div.withConfig({
	    displayName: "article__HeadingText",
	    componentId: "rp54u7-17"
	})([""]);
	
	var blockListicle = (0, _styledComponents.css)(["display:flex;flex-direction:column;align-items:center;padding-bottom:8px;margin-top:78px;", "{margin-bottom:78px;}", "{border:2px solid black;box-sizing:border-box;width:100%;}", "{margin:35px 0 28px;text-align:center;max-width:720px;", ",", "{margin-top:30px;display:inline;font-family:'GT America Condensed Bold';font-size:32px;line-height:40px;text-transform:uppercase;}", "{color:#F03232;margin-right:8px;}}", "{font-size:20px;line-height:34px;", "}", ""], Line, Img, Heading, Number, HeadingText, Number, Text, _utils.media.phone(_templateObject10), _utils.media.phone(_templateObject13, Heading, Number, HeadingText, Number, Line, Image));
	
	// Block QA
	
	var Question = _styledComponents2.default.div.withConfig({
	    displayName: "article__Question",
	    componentId: "rp54u7-18"
	})([""]);
	var Answer = _styledComponents2.default.div.withConfig({
	    displayName: "article__Answer",
	    componentId: "rp54u7-19"
	})([""]);
	
	var blockQA = (0, _styledComponents.css)(["     ", ",", "{font-size:20px;line-height:34px;", "}", "{font-weight:500;margin-bottom:16px;}"], Question, Answer, _utils.media.phone(_templateObject10), Question);
	
	// Block Video
	
	var blockQuote = (0, _styledComponents.css)(["", "{font-size:40px;line-height:60px;font-family:'GT America Condensed Bold';", "}"], Text, _utils.media.phone(_templateObject14));
	
	// Block Video
	
	var blockVideo = (0, _styledComponents.css)([""]);
	
	// Block Spotify
	
	var blockSpotify = (0, _styledComponents.css)(["     iframe{width:100%;}"]);
	
	// Tags
	
	var TagSection = _styledComponents2.default.div.withConfig({
	    displayName: "article__TagSection",
	    componentId: "rp54u7-20"
	})(["display:flex;flex-direction:column;align-items:center;max-width:", ";padding:0 20px;box-sizing:border-box;width:100%;margin-top:80px;", ""], blockWidth, _utils.media.phone(_templateObject15));
	
	var Tags = _styledComponents2.default.div.withConfig({
	    displayName: "article__Tags",
	    componentId: "rp54u7-21"
	})(["display:flex;flex-direction:row;margin-bottom:77px;", ""], _utils.media.phone(_templateObject16));
	
	var Tag = _styledComponents2.default.div.withConfig({
	    displayName: "article__Tag",
	    componentId: "rp54u7-22"
	})(["padding:0 6px;border:2px solid black;height:20px;display:flex;justify-content:center;align-items:center;font-family:'GT America Expanded Bold';font-size:12px;text-transform:uppercase;font-size:9px;color:black;padding-bottom:1px;box-sizing:border-box;&:not(:last-child){margin-right:5px;}", ""], _utils.media.phone(_templateObject17));
	
	// Shop
	
	var Shop = _styledComponents2.default.div.withConfig({
	    displayName: "article__Shop",
	    componentId: "rp54u7-23"
	})(["width:100%;margin-top:4px;max-width:", ";padding:0 20px;box-sizing:border-box;", "{margin:70px 0;font-family:'GT America Expanded Bold';font-size:20px;color:#000000;letter-spacing:0;text-align:center;", "}"], blockWidth, Heading, _utils.media.phone(_templateObject18));
	
	var Products = _styledComponents2.default.div.withConfig({
	    displayName: "article__Products",
	    componentId: "rp54u7-24"
	})(["display:flex;justify-content:center;flex-flow:row wrap;", ""], _utils.media.phone(_templateObject19));
	
	var Product = _styledComponents2.default.a.withConfig({
	    displayName: "article__Product",
	    componentId: "rp54u7-25"
	})(["border:2px solid black;display:flex;flex-direction:column;justify-content:center;flex:0 1 350px;max-width:350px;margin-bottom:40px;", "{height:350px;}&:nth-child(odd){margin-right:40px;}", ""], Image, _utils.media.phone(_templateObject20, Image));
	
	var Info = _styledComponents2.default.div.withConfig({
	    displayName: "article__Info",
	    componentId: "rp54u7-26"
	})(["font-family:'GT America Expanded Bold';font-size:15px;text-align:center;text-transform:uppercase;color:black;height:60px;border-top:2px solid black;display:flex;justify-content:center;align-items:center;padding:0 10px;box-sizing:border-box;&:hover{color:white;background:black;}"]);
	
	// Share
	
	var Share = _styledComponents2.default.div.withConfig({
	    displayName: "article__Share",
	    componentId: "rp54u7-27"
	})(["height:123px;width:232px;display:flex;flex-direction:column;background:white;user-select:none;border:2px solid #000000;box-shadow:-10px 10px 0 0 #000000;box-sizing:border-box;transform:translate(128px,-50%) rotate(-90deg);transition:transform 0.25s ease;cursor:pointer;position:absolute;top:1550px;right:0;", "{font-family:'GT America Expanded Bold';font-size:15px;text-transform:uppercase;border-top:2px solid black;height:48px;display:flex;justify-content:center;align-items:center;transform:rotate(-180deg);}", " &.fixed{position:fixed;top:50vh;right:0;}", ""], Heading, function (props) {
	    if (props.active) return (0, _styledComponents.css)(["transform:translate(18px,-50%) rotate(-90deg);"]);
	
	    if (!props.active) return (0, _styledComponents.css)(["&:hover{transform:translate(113px,-50%) rotate(-90deg);", "}"], _utils.media.phone(_templateObject21));
	}, _utils.media.phone(_templateObject22, Heading));
	
	var Functions = _styledComponents2.default.div.withConfig({
	    displayName: "article__Functions",
	    componentId: "rp54u7-28"
	})(["display:flex;align-items:center;flex:1;"]);
	
	var Function = _styledComponents2.default.a.withConfig({
	    displayName: "article__Function",
	    componentId: "rp54u7-29"
	})(["     ", " flex:1;display:flex;align-items:center;justify-content:center;height:100%;cursor:pointer;", "{transition:all 0.25s ease;transform:rotate(90deg)}&:not(:last-child){border-right:2px solid black;}", " &:hover{", "{transform:rotate(75deg)}}", ""], _global.bgIcon, Image, function (props) {
	    if (props.type == 'facebook') return (0, _styledComponents.css)(["", "{background-image:url(", ");width:28px;height:39px;", "}"], Image, _facebook2.default, _utils.media.phone(_templateObject23));
	
	    if (props.type == 'twitter') return (0, _styledComponents.css)(["", "{background-image:url(", ");width:40px;height:35px;", "}"], Image, _twitter2.default, _utils.media.phone(_templateObject24));
	
	    if (props.type == 'mail') return (0, _styledComponents.css)(["", "{background-image:url(", ");width:43px;height:29px;", "}"], Image, _mail2.default, _utils.media.phone(_templateObject25));
	}, Image, _utils.media.phone(_templateObject26, Image));
	
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";
	
	exports.default = Article;

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-article-article-js-6cb40f2be740af1201f1.js